export default __webpack_public_path__ + "75db288e383a3056d3214c0220a256c8.png";